import React, { useState } from 'react';
import { customerApi, formatApiError } from '../services/api';
import { UserPlus } from '@phosphor-icons/react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { toast } from 'sonner';

const QuickCustomerCreate = ({ open, onOpenChange, onCreated }) => {
  const [form, setForm] = useState({
    first_name: '', last_name: '', email: '', phone: '',
    address: '', postal_code: '', city: '', country: 'Deutschland'
  });
  const [creating, setCreating] = useState(false);

  const update = (field, value) => setForm(prev => ({ ...prev, [field]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.first_name || !form.last_name) return;
    setCreating(true);
    try {
      const payload = { ...form };
      if (!payload.email) delete payload.email;
      if (!payload.phone) delete payload.phone;
      if (!payload.address) delete payload.address;
      if (!payload.postal_code) delete payload.postal_code;
      if (!payload.city) delete payload.city;

      const res = await customerApi.createQuick(payload);
      toast.success(`Kunde ${form.first_name} ${form.last_name} angelegt`);
      onCreated(res.data);
      onOpenChange(false);
      setForm({ first_name: '', last_name: '', email: '', phone: '', address: '', postal_code: '', city: '', country: 'Deutschland' });
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setCreating(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <UserPlus weight="bold" size={20} />
            Schnell-Kundenanlage
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label className="overline">Vorname *</Label>
              <Input value={form.first_name} onChange={e => update('first_name', e.target.value)} className="input-swiss" required data-testid="quick-customer-firstname" />
            </div>
            <div>
              <Label className="overline">Nachname *</Label>
              <Input value={form.last_name} onChange={e => update('last_name', e.target.value)} className="input-swiss" required data-testid="quick-customer-lastname" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label className="overline">E-Mail</Label>
              <Input type="email" value={form.email} onChange={e => update('email', e.target.value)} className="input-swiss" />
            </div>
            <div>
              <Label className="overline">Telefon</Label>
              <Input value={form.phone} onChange={e => update('phone', e.target.value)} className="input-swiss" />
            </div>
          </div>
          <div>
            <Label className="overline">Straße & Hausnr.</Label>
            <Input value={form.address} onChange={e => update('address', e.target.value)} className="input-swiss" placeholder="z.B. Musterstraße 12" data-testid="quick-customer-address" />
          </div>
          <div className="grid grid-cols-3 gap-3">
            <div>
              <Label className="overline">PLZ</Label>
              <Input value={form.postal_code} onChange={e => update('postal_code', e.target.value)} className="input-swiss" placeholder="z.B. 10115" data-testid="quick-customer-plz" />
            </div>
            <div className="col-span-2">
              <Label className="overline">Stadt</Label>
              <Input value={form.city} onChange={e => update('city', e.target.value)} className="input-swiss" placeholder="z.B. Berlin" data-testid="quick-customer-city" />
            </div>
          </div>
          <p className="text-xs text-[#8A94A6]">Nur Vorname & Nachname sind Pflicht. Weitere Daten (Führerschein etc.) können später unter Kunden ergänzt werden.</p>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Abbrechen</Button>
            <Button type="submit" className="btn-primary" disabled={!form.first_name || !form.last_name || creating} data-testid="submit-quick-customer">
              {creating ? 'Wird angelegt...' : 'Anlegen & auswählen'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default QuickCustomerCreate;
